var _excluded = ["srcData", "alt", "hasLazyLoading"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useRef } from "react";
import styled from "styled-components";
import useIsVisibleInViewPort from "../../../hooks/useIsVisibleInViewPort";
import isNotEmpty from "../../../utils/isNotEmpty";
import PictureSource, { SourceMediaBreakpoints } from "./components/PictureSource";
import { getImageDataObject } from "./helpers/getImageDataObject";
import { ImageType } from "./helpers/getSrcSetPicture";
import { defaultProps } from "./Picture.types";
var StyledImage = styled.img.withConfig({
  componentId: "sc-jtgaad-0"
})(["height:auto;"]);
function Picture(_ref) {
  var srcData = _ref.srcData,
    alt = _ref.alt,
    _ref$hasLazyLoading = _ref.hasLazyLoading,
    hasLazyLoading = _ref$hasLazyLoading === void 0 ? defaultProps.hasLazyLoading : _ref$hasLazyLoading,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var ref = useRef(null);
  var isVisibleInViewPort = useIsVisibleInViewPort(ref);
  var imgData = null;
  var _ref2 = srcData,
    small = _ref2.small,
    medium = _ref2.medium,
    large = _ref2.large;
  if (isNotEmpty(large)) {
    imgData = getImageDataObject(large, alt);
  } else if (isNotEmpty(srcData)) {
    imgData = getImageDataObject(srcData, alt);
  }
  if (!isNotEmpty(imgData)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("picture", null, isNotEmpty(small) ? /*#__PURE__*/React.createElement(React.Fragment, null, _typeof(small) === "object" && small.srcWebp ? /*#__PURE__*/React.createElement(PictureSource, {
    imgData: small,
    sourceBreakpoint: SourceMediaBreakpoints.SMALL,
    imageType: ImageType.WEBP
  }) : null, _typeof(small) === "object" && small.srcAvif ? /*#__PURE__*/React.createElement(PictureSource, {
    imgData: small,
    sourceBreakpoint: SourceMediaBreakpoints.SMALL,
    imageType: ImageType.AVIF
  }) : null, typeof small === "string" || _typeof(small) === "object" ? /*#__PURE__*/React.createElement(PictureSource, {
    imgData: small,
    sourceBreakpoint: SourceMediaBreakpoints.SMALL
  }) : null) : null, isNotEmpty(medium) ? /*#__PURE__*/React.createElement(React.Fragment, null, _typeof(medium) === "object" && medium.srcWebp ? /*#__PURE__*/React.createElement(PictureSource, {
    imgData: medium,
    sourceBreakpoint: SourceMediaBreakpoints.MEDIUM,
    imageType: ImageType.WEBP
  }) : null, _typeof(medium) === "object" && medium.srcAvif ? /*#__PURE__*/React.createElement(PictureSource, {
    imgData: medium,
    sourceBreakpoint: SourceMediaBreakpoints.MEDIUM,
    imageType: ImageType.AVIF
  }) : null, typeof medium === "string" || _typeof(medium) === "object" ? /*#__PURE__*/React.createElement(PictureSource, {
    imgData: medium,
    sourceBreakpoint: SourceMediaBreakpoints.MEDIUM
  }) : null) : null, isNotEmpty(large) && _typeof(large) === "object" ? /*#__PURE__*/React.createElement(React.Fragment, null, large.srcWebp ? /*#__PURE__*/React.createElement(PictureSource, {
    imgData: large,
    sourceBreakpoint: SourceMediaBreakpoints.LARGE,
    imageType: ImageType.WEBP
  }) : null, large.srcAvif ? /*#__PURE__*/React.createElement(PictureSource, {
    imgData: large,
    sourceBreakpoint: SourceMediaBreakpoints.LARGE,
    imageType: ImageType.AVIF
  }) : null) : null, /*#__PURE__*/React.createElement(StyledImage, _extends({
    ref: ref,
    loading: !isVisibleInViewPort && hasLazyLoading ? "lazy" : undefined
  }, imgData, restProps)));
}
export default Picture;